import { RiderTypeCode } from '@app/domain/model/eshop/transport/RiderTypeCode';

export function shouldShowReadMore(typeCode: string): boolean {
    return typeCode !== RiderTypeCode.DriverPassenger && typeCode !== RiderTypeCode.CascoMtplRider;
}
